<script>
  import { footerBannerPage, changeBannerStatus } from '@/api/footerBanner'
  import { getDriverAreaTree } from '@/api/vehicle/vehicle-manage'
  import bannerEdit from './BannerEdit.vue'
  import RejectDialog from './RejectDialog.vue'
  import TimeModifyDialog from './TimeModifyDialog.vue'
  import BannerDetail from './BannerDetail.vue'
  import { getAdGroupStatusMap, getBannerPosition } from '../config/format'
  import { getPageEnumList } from '@/api/marketing/advertising'
  import { getBannerDetail } from '../../../../api/footerBanner'
  import DataView from './data-view'

  export default {
    name: 'BannerList',
    components: { bannerEdit, RejectDialog, TimeModifyDialog, BannerDetail, DataView },
    props: {
      // 是否隐藏广告组名称过滤器
      hideGroupNameFilter: {
        type: Boolean,
        default: false
      },
      // 额外的查询参数
      extraQueryParams: {
        type: Object,
        default: () => ({})
      },
      // 自定义表格配置
      customTableConfig: {
        type: Object,
        default: () => ({
          showSelection: false
        })
      },
      // 是否显示添加按钮（当在父组件中已有添加按钮时，可以设置为false）
      showAddButton: {
        type: Boolean,
        default: true
      },
      useCache: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        loading: false,
        searchFormItems: [
          {
            type: 'el-input',
            label: 'Banner名称',
            prop: 'bannerName'
          },
          {
            type: 'select',
            label: '状态',
            prop: 'status',
            options: [
              { label: '全部', value: '' },
              { label: '待审核', value: 1 },
              { label: '进行中', value: 4 },
              { label: '审核未通过', value: 2 },
              { label: '未开始', value: 3 },
              { label: '已下架', value: 5 }
            ]
          },
          {
            type: 'daterange',
            label: '展示时间',
            prop: 'time'
          },
          {
            type: 'el-input',
            label: '创建人',
            prop: 'createUserName'
          },
          {
            type: 'slot',
            label: '展示地区',
            prop: 'areaCode',
            slot: 'areaSlot'
          },
          {
            type: 'el-input',
            label: '广告组名称',
            prop: 'bannerGroupName'
          },
          {
            type: 'select',
            label: '展示页面',
            prop: 'displayPage',
            options: []
          }
        ],
        initVals: {
          bannerName: '',
          status: '',
          areaCode: '',
          createUserName: '',
          bannerGroupName: ''
        },
        query: {},
        displayChannelMap: {
          1: '微信小程序',
          2: 'APP',
          3: '云闪付',
          4: '支付宝小程序'
        },
        tableData: [],
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10
        },
        editVisible: false,
        rejectDialogVisible: false,
        timeModifyDialogVisible: false,
        detailVisible: false,
        targetStatus: null,
        currentBanner: {},
        selectedBanners: [],
        bannerId: ''
      }
    },
    created() {
      let bannerListParams = sessionStorage.getItem('bannerListParams')
      if (bannerListParams && this.useCache) {
        bannerListParams = JSON.parse(bannerListParams)
        this.query = { ...bannerListParams }
      }
      getPageEnumList().then((res) => {
        const { code, data } = res
        if (code === 0) {
          this.$set(this.searchFormItems, 6, {
            ...this.searchFormItems[6],
            options: data.bannerDisplayPage || []
          })
        }
      })
    },
    computed: {
      filteredSearchItems() {
        if (this.hideGroupNameFilter) {
          return this.searchFormItems.filter((item) => item.prop !== 'bannerGroupName')
        }
        return this.searchFormItems
      },
      btnBold() {
        return (prop, row) => {
          // 待审核 =》 1 | 未通过 =》 2 | 未开始 =》 3 | 进行中 =》 4 | 已下架 => 5
          const map = new Map([
            ['edit', new Set([1, 2, 3, 5])],
            ['pass', new Set([1])],
            ['noPass', new Set([1])],
            ['offLine', new Set([4])],
            ['onLine', new Set([5])],
            ['data', new Set([4])]
          ])
          const set = map.get(prop) || new Set()
          return set.has(row.status)
        }
      }
    },
    methods: {
      getAdGroupStatusMap,
      getBannerPosition,
      getDriverAreaTree,
      fieldFormat(data) {
        data.unshift({
          id: 'all',
          areaCode: 'all',
          areaName: '全部',
          children: []
        })
        data.forEach((item) => {
          item.children &&
            item.children.forEach((child) => {
              child.children = null
            })
        })
        const search = (list) => {
          for (let i = 0; i < list.length; i++) {
            const { children } = list[i]
            if (Array.isArray(children) && children.length > 0) {
              list[i].childAreaManage = children
              search(children)
            }
          }
        }
        search(data)
        return data
      },
      // 获取列表数据
      getList() {
        this.loading = true
        const { time, areaCode, ...rest } = this.query
        const params = {
          ...rest,
          ...this.extraQueryParams,
          size: this.pagination.pageSize,
          current: this.pagination.current,
          areaCode: areaCode === 'all' ? 0 : areaCode
        }
        if (time && time.length > 0) {
          params.startTime = time[0]
          params.endTime = time[1]
        }
        footerBannerPage(params)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              const { records = [], total = 0, size = 10, current = 1 } = data || {}
              // this.tableData = [...records].sort((a, b) => {
              //   // 首先按模板名称排序
              //   if (a.bannerGroupId < b.bannerGroupId) return -1
              //   if (a.bannerGroupId > b.bannerGroupId) return 1
              //
              //   return 0
              // })
              this.tableData = records
              this.pagination = {
                ...this.pagination,
                total,
                current,
                pageSize: size
              }
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      // 搜索
      handleSearch(form) {
        Object.assign(this.query, form)
        this.pagination.current = 1
        this.getList()
      },
      // 重置搜索
      handleReset(form) {
        Object.assign(this.query, form)
        this.pagination.current = 1
        this.getList()
      },
      // 处理页码变化
      onTableChange({ current, pageSize }) {
        this.pagination.pageSize = pageSize
        this.pagination.current = current
        this.getList()
      },
      // 渲染状态标签
      renderStatusTag(status) {
        const statusMap = {
          1: { type: 'primary', text: '待审核' },
          2: { type: 'danger', text: '未通过' },
          3: { type: 'info', text: '未开始' },
          4: { type: 'success', text: '进行中' },
          5: { type: 'warning', text: '已下架' }
        }
        return statusMap[status] || { type: '', text: status }
      },
      // 格式化展示渠道
      formatDisplayChannel(channels) {
        if (!channels) return ''
        return channels
          .split(',')
          .map((ch) => this.displayChannelMap[ch] || ch)
          .join('、')
      },
      // 修改状态
      changeStatus(status, row) {
        if (status === 2) {
          // 不通过，打开拒绝弹窗
          this.currentBanner = row
          this.rejectDialogVisible = true
          return
        }

        const stateMap = {
          5: '下架后不再展示该广告！',
          998: '',
          999: '确定通过审核吗？'
        }

        const tipMap = {
          5: '确定下架吗',
          998: '确定上架吗'
        }

        const httpFunc = () => {
          changeBannerStatus({
            id: row.id,
            status
          }).then((res) => {
            if (res.code === 0) {
              if (status === 999 || status === 998) {
                if (res.data === false) {
                  this.currentBanner = row
                  this.targetStatus = status
                  this.timeModifyDialogVisible = true
                } else {
                  this.$message.success('操作成功')
                  this.getList()
                }
              } else {
                this.$message.success('操作成功')
                this.getList()
              }
            }
          })
        }

        if (stateMap[status] || stateMap[status] === '') {
          this.$confirm(stateMap[status], tipMap[status] || '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '稍后再看',
            type: 'warning',
            center: true
          }).then(() => {
            httpFunc()
          })
        } else {
          httpFunc()
        }
      },
      // 模拟检查时间是否过期
      checkTimeExpired(row, status) {
        // 模拟接口调用
        // 这里可以替换为实际的接口调用
        const now = new Date()
        const endTime = row.endTime ? new Date(row.endTime) : null

        // 如果结束时间已过或未设置，显示修改时间弹窗
        if (!endTime || endTime < now) {
          this.currentBanner = row
          this.targetStatus = status
          this.timeModifyDialogVisible = true
        } else {
          // 时间未过期，直接调用状态修改接口
          this.directChangeStatus(row.id, status)
        }
      },
      // 直接修改状态
      directChangeStatus(data, status) {
        const { id, startTime, endTime } = data
        changeBannerStatus({
          id,
          status,
          startTime,
          endTime
        }).then((res) => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.getList()
          }
        })
      },
      // 处理时间修改确认
      handleTimeModifyConfirm(data) {
        // 先更新时间
        // 这里应该调用更新时间的接口
        console.log('更新时间', data)

        // 然后修改状态
        this.directChangeStatus(data, this.targetStatus)
        this.timeModifyDialogVisible = false
      },
      // 处理拒绝确认
      handleRejectConfirm(data) {
        changeBannerStatus({
          id: data.id,
          status: 2,
          refuseReason: data.reason
        }).then((res) => {
          if (res.code === 0) {
            this.$message.success('已拒绝审核')
            this.rejectDialogVisible = false
            this.getList()
          }
        })
      },
      // 新增banner
      addBanner() {
        this.currentBanner = null
        this.editVisible = true
      },
      // 编辑banner
      editBanner(row) {
        getBannerDetail(row.id).then((res) => {
          const { code, data } = res
          if (code === 0) {
            this.currentBanner = data
            this.editVisible = true
          }
        })
      },
      // 显示banner详情
      showBannerDetail(row) {
        this.currentBanner = row
        this.bannerId = row.id
        this.detailVisible = true
      },
      // 删除banner
      deleteBanner(row) {
        this.$confirm('确认删除该Banner?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeStatus(5, row)
        })
      },
      // 处理表格选择变化
      handleSelectionChange(selection) {
        // 如果需要在组件内部使用选中的数据，可以保存在本地
        this.selectedBanners = selection
      },

      dataView(obj) {
        this.$refs.dataView.init(obj.id, obj.name)
      },

      success() {
        console.log('操作成功')
        this.getList()
      },

      // 处理单元格合并
      handleSpanMethod({ row, column, rowIndex, columnIndex }) {
        // 只处理广告组列(第2列)的合并
        if (columnIndex === 1) {
          // 获取当前行的广告组ID
          const currentGroupId = row.bannerGroupId

          // 寻找该广告组ID第一次出现的位置
          const firstIndex = this.tableData.findIndex(
            (item) => item.bannerGroupId === currentGroupId
          )

          // 如果当前行是该广告组第一次出现
          if (rowIndex === firstIndex) {
            // 计算相同广告组ID的行数
            const count = this.tableData.filter(
              (item) => item.bannerGroupId === currentGroupId
            ).length
            return { rowspan: count, colspan: 1 }
          } else {
            // 如果不是第一次出现，不显示该单元格
            return { rowspan: 0, colspan: 0 }
          }
        }

        // 其他列不合并
        return { rowspan: 1, colspan: 1 }
      }
    }
  }
</script>

<template>
  <div>
    <!-- 搜索栏 -->
    <YDSearchForm
      :form-items="filteredSearchItems"
      :initial-values="initVals"
      @search="handleSearch"
      @reset="handleReset"
      @add="addBanner"
      :show-add="showAddButton"
      permi="user_advertising_edit"
      :useCache="useCache"
      :cache-options="{
        type: 'session',
        key: 'bannerListParams'
      }"
    >
      <template #areaSlot="{ formData }">
        <YdCitySelect
          mode="1"
          placeholder="请选择地级归属"
          :customHttp="getDriverAreaTree"
          :fieldFormat="fieldFormat"
          v-model="formData.areaCode"
        />
      </template>
    </YDSearchForm>

    <!-- 自定义操作区域插槽 -->
    <slot name="operation-area"></slot>

    <!-- Banner列表 -->
    <yd-table
      ref="bannerTable"
      :data="tableData"
      :pagination="pagination"
      :loading="loading"
      @onChange="onTableChange"
      @selection-change="handleSelectionChange"
      :span-method="handleSpanMethod"
    >
      <!-- 选择列 -->
      <el-table-column
        v-if="customTableConfig.showSelection"
        type="selection"
        width="55"
        align="center"
      />

      <el-table-column prop="name" label="Banner名称" align="center" min-width="150px">
        <template slot-scope="scope">
          <div>{{ scope.row.id }}</div>
          <el-link type="primary" @click="showBannerDetail(scope.row)">{{
            scope.row.name
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="bannerGroupName" label="所属广告组" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.bannerGroupName }}</div>
          <span :class="['status-text', `status-${row.bannerGroupStatus}`]">
            {{ getAdGroupStatusMap({ state: row.bannerGroupStatus }) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="displayPage" label="展示页面" align="center" />
      <el-table-column prop="slotKey" label="组内位置" align="center">
        <template slot-scope="{ row }">
          {{ getBannerPosition({ slotKey: row.slotKey }) }}
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="权重" width="80" align="center" />
      <el-table-column label="图片" min-width="100" align="center">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.imgUrl"
            style="width: 60px; height: 60px"
            :src="scope.row.imgUrl"
            fit="cover"
            :preview-src-list="[scope.row.imgUrl]"
          />
          <el-image
            v-if="scope.row.marketImgUrl"
            style="width: 60px; height: 60px; margin-left: 5px"
            :src="scope.row.imgUrl"
            fit="cover"
            :preview-src-list="[scope.row.marketImgUrl]"
          />
        </template>
      </el-table-column>
      <el-table-column label="展示渠道" align="center">
        <template slot-scope="scope">
          {{ formatDisplayChannel(scope.row.displayChannel) }}
        </template>
      </el-table-column>
      <el-table-column label="展示地区" align="center" width="200px" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <div style="width: 180px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden">
            {{ row.allArea === 1 ? '全部' : row.areaNameList ? row.areaNameList.join(',') : '' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="renderStatusTag(scope.row.status).type" size="small">
            {{ renderStatusTag(scope.row.status).text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.startTime }}
        </template>
      </el-table-column>
      <el-table-column label="结束时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <!-- 自定义操作列插槽 -->
          <slot name="operation" :row="scope.row">
            <!--            v-has-permi="['user_advertising_edit']"-->
            <el-button
              type="text"
              size="mini"
              @click="editBanner(scope.row)"
              v-if="btnBold('edit', scope.row)"
            >
              编辑
            </el-button>
            <!--            v-has-permi="['user_advertising_review']"-->
            <el-button
              type="text"
              size="mini"
              @click="changeStatus(999, scope.row)"
              v-if="btnBold('pass', scope.row)"
            >
              通过
            </el-button>
            <!--            v-has-permi="['user_advertising_review']"-->
            <el-button
              type="text"
              size="mini"
              class="danger-button"
              v-if="btnBold('noPass', scope.row)"
              @click="changeStatus(2, scope.row)"
            >
              不通过
            </el-button>
            <!--            v-has-permi="['user_advertising_status']"-->
            <el-button
              type="text"
              size="mini"
              class="danger-button"
              @click="changeStatus(5, scope.row)"
              v-if="btnBold('offLine', scope.row)"
            >
              下架
            </el-button>
            <!--            v-has-permi="['user_advertising_status']"-->
            <el-button
              type="text"
              size="mini"
              @click="changeStatus(998, scope.row)"
              v-if="btnBold('onLine', scope.row)"
            >
              上架
            </el-button>
            <!--            v-has-permi="['user_advertising_data']"-->
            <el-button
              type="text"
              @click="dataView(scope.row)"
              v-if="btnBold('data', scope.row)"
              size="mini"
              >数据</el-button
            >
          </slot>
        </template>
      </el-table-column>
    </yd-table>
    <bannerEdit
      v-if="editVisible"
      :visible.sync="editVisible"
      :title="currentBanner ? '编辑' : '新增'"
      :is-edit="!!currentBanner"
      :edit-data="currentBanner"
      @success="success"
      :ad-group-id="extraQueryParams.bannerGroupId"
      :template-id="extraQueryParams.templateId"
      :displayPageName="extraQueryParams.displayPageName"
    />
    <RejectDialog
      :visible.sync="rejectDialogVisible"
      :bannerId="currentBanner ? currentBanner.id : ''"
      @confirm="handleRejectConfirm"
    />
    <TimeModifyDialog
      :visible.sync="timeModifyDialogVisible"
      :bannerId="currentBanner ? currentBanner.id : ''"
      :currentStartTime="currentBanner ? currentBanner.startTime : ''"
      :currentEndTime="currentBanner ? currentBanner.endTime : ''"
      @confirm="handleTimeModifyConfirm"
    />
    <BannerDetail :visible.sync="detailVisible" :banner-id="bannerId" />
    <data-view ref="dataView" />
  </div>
</template>

<style scoped>
  .banner-list-container .danger-button {
    color: #f56c6c;
  }
  .status-text {
    display: inline-block;
    padding: 0 10px;
    height: 24px;
    line-height: 22px;
    font-size: 12px;
    border-radius: 12px;
    box-sizing: border-box;
    white-space: nowrap;

    &.status-0 {
      color: #909399;
      background-color: rgba(144, 147, 153, 0.1);
      border: 1px solid rgba(144, 147, 153, 0.2);
    }

    &.status-1 {
      color: #e6a23c;
      background-color: rgba(230, 162, 60, 0.1);
      border: 1px solid rgba(230, 162, 60, 0.2);
    }

    &.status-2 {
      color: #f56c6c;
      background-color: rgba(245, 108, 108, 0.1);
      border: 1px solid rgba(245, 108, 108, 0.2);
    }

    &.status-3 {
      color: #67c23a;
      background-color: rgba(103, 194, 58, 0.1);
      border: 1px solid rgba(103, 194, 58, 0.2);
    }

    &.status-4 {
      color: #909399;
      background-color: rgba(144, 147, 153, 0.1);
      border: 1px solid rgba(144, 147, 153, 0.2);
    }
  }
</style>
